import {
  getData,
} from 'src/services/RestApi';
import { formatDate } from 'src/utils/date-locale';
import StringUtils from 'src/utils/string-util';
import { TicketStatusMap, DefaultStatus } from 'src/constants/status-maps';
import { formatDecimal, formatQuantity, calculateTotalFuel } from 'src/utils/formatters';

/**
 * Ticket
 */
export const getTicketList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/ticket/list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) {
    return onError(error);
  }

  result.forEach((element) => {
    element.createdAt = formatDate(element.createdAt, 'dd/MM/yy - HH:mm');
  });
  return onSuccess(result);
};

export const getTicketItem = async (payload) => {
  const ticketId = Number(payload?.id) || 0;
  if (ticketId === 0) return {};

  const { result, error } = await getData('api/ticket/detail', { ticketId });
  if(error) return {};

  result.createdAt = formatDate(result.createdAt, 'dd/MM/yyyy - HH:mm:ss');
  result.ticketInfo = TicketStatusMap[result.ticketStatus] || DefaultStatus;

  return result;
};
// EOF

/**
 * TMS
 */
export const getTmsList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/tms/censor-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) {
    return onError(error);
  }

  result.forEach((element) => {
    if(element.checkOut > 0)
      element.distance = formatDecimal(element.checkoutKm - element.checkinKm);
    element.checkIn = formatDate(element.checkIn, 'dd/MM/yy - HH:mm');
    element.checkOut = formatDate(element.checkOut, 'dd/MM/yy - HH:mm');
    element.checkinBy = formatDate(element.checkinBy, 'HH:mm');
    element.checkoutBy = formatDate(element.checkoutBy, 'HH:mm');
  });
  return onSuccess(result);
};

export const getTmsItem = async (payload) => {
  const tmsId = Number(payload?.id) || 0;
  if (tmsId === 0) return {};

  const { result, error } = await getData('api/tms/detail', { tmsId });
  if(error) return {};

  result.checkinSys = formatDate(result.checkIn, 'dd/MM/yy - HH:mm:ss');
  result.checkoutSys = formatDate(result.checkOut, 'dd/MM/yy - HH:mm:ss');
  result.checkinHint = result.checkinBy || result.checkIn;
  result.checkoutHint = result.checkoutBy || result.checkOut;

  return result;
};

export const getTmsNew = async () => {
  const { result } = await getData('api/tms/censor-new', {});
  const length = result.length; 
  // const randomIndex = Math.floor(Math.random() * length);
  // const reducedList = result.filter((_, index) => index !== randomIndex);
  
  return { total: length, list: result };
};
// EOF

/**
 * FUEL
 */
export const getFuelList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/fuel/censor-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);
  
  result.forEach((element) => {
    element.fuelDate = formatDate(element.fuelDate, 'dd/MM/yy');
    element.fuelQuantity = formatQuantity(element.fuelQuantity);
    element.cardNumber = StringUtils.getLastNChars(result.cardNumber, 4);
    element.fuelPrice = formatDecimal(element.fuelPrice);
  });
  return onSuccess(result);
}

export const getFuelItem = async (payload) => {
  const fuelId = Number(payload?.id) || 0;
  if (fuelId === 0) return {};

  let { result, error } = await getData('api/fuel/detail', { fuelId });
  if(error) return {};

  const quantity = result.quantity;
  result.totalPrice = calculateTotalFuel(quantity, result.price);
  result.quantity = formatQuantity(quantity);

  result.cardNumber = StringUtils.getLastNChars(result.cardNumber, 4);
  result.paidDate = formatDate(result.paidDate, 'dd/MM/yyyy');

  return result;
};

export const getFuelNew = async () => {
  const { result } = await getData('api/fuel/censor-new', {});
  const length = result.length; 
  // const randomIndex = Math.floor(Math.random() * length);
  // const reducedList = result.filter((_, index) => index !== randomIndex);
  
  return { total: length, list: result };
};
// EOF